/**
 * Configuration for different environments
 */

// Determine the API URL based on the environment
const getApiUrl = () => {
  // In production (deployed site), use the production backend
  if (window.location.hostname === 'cut-creator.com') {
    return 'https://cutlist-project.onrender.com';
  }
  
  // In development (localhost), use local backend
  return 'http://localhost:5000';
};

export const API_URL = getApiUrl();

// Always log the API URL for debugging
console.log('🔗 API URL:', API_URL);
console.log('🌐 Hostname:', window.location.hostname);
